<main class="filters">
  <form
    class="filters__form"
    [formGroup]="form"
    (submit)="submitForm($event)"
  >
    <section>
      <h3 class="filters__label">Tipo de data</h3>
      <fieldset class="filters__radios">
        <label class="cds-input-wrapper">
          <input type="radio" class="cds-radio" value="payment" formControlName="date_type" />
          Pagamento
        </label>
        <label class="cds-input-wrapper">
          <input type="radio" class="cds-radio" value="due" formControlName="date_type" />
          Vencimento
        </label>
      </fieldset>

      <cds-input-wrapper label="Período">
        <cds-dropdown
          placeholder="Selecione"
          [options]="periodOptions"
          [value]="period()"
          (optionSelected)="setPeriod($event)"
        />
      </cds-input-wrapper>

      <!--
        Always visible, even with a preset chosen: they show the interval it
        derived — see the `setPeriod` docblock.
      -->
      <div class="cds-grid-12">
        <cds-input-wrapper label="Data início" class="cds-span-6">
          <cds-datepicker formControlName="date_range_start" placeholder="dd/mm/aaaa" />
        </cds-input-wrapper>
        <cds-input-wrapper label="Data fim" class="cds-span-6">
          <cds-datepicker formControlName="date_range_end" placeholder="dd/mm/aaaa" />
        </cds-input-wrapper>
      </div>

      <h3 class="filters__label">Tipo de registro</h3>
      <fieldset class="filters__radios">
        <label class="cds-input-wrapper">
          <input type="radio" class="cds-radio" [value]="null" formControlName="financial_record_type" />
          Todos
        </label>
        <label class="cds-input-wrapper">
          <input type="radio" class="cds-radio" value="revenue" formControlName="financial_record_type" />
          Somente entradas
        </label>
        <label class="cds-input-wrapper">
          <input type="radio" class="cds-radio" value="expense" formControlName="financial_record_type" />
          Somente saídas
        </label>
      </fieldset>

      <div class="cds-grid-12">
        <cds-input-wrapper label="Categoria" class="cds-span-6">
          <cds-coa-autocomplete formControlName="classification_pk" [activeCoaPk]="activeCoaPk()" />
        </cds-input-wrapper>
        <cds-input-wrapper label="Setor/Projeto" class="cds-span-6">
          <cost-center-autocomplete formControlName="cost_center_pk" [companyPk]="companyPk()" />
        </cds-input-wrapper>
      </div>

      <!--
        R1: Banco and Conta, as in the "Realizados" modal. "Conta" opens up from the bank
        chosen, and only lists that bank's accounts.
      -->
      <div class="cds-grid-12">
        <cds-input-wrapper label="Banco" class="cds-span-6">
          <cds-banks-selector
            placeholderInput="Todos"
            [isFormField]="true"
            [showInitialImage]="false"
            [whiteList]="banksWithAccounts()"
            [selectedBank]="selectedBank()"
            (bankHasBeenSelected)="selectBank($event)"
          />
        </cds-input-wrapper>
        <cds-input-wrapper label="Conta" class="cds-span-6">
          <cds-checking-account-dropdown
            placeholderInput="Todas"
            keyField="pk"
            [formControl]="form.controls.checking_accounts"
            [checkingAccounts]="accountsOfSelectedBank()"
          />
        </cds-input-wrapper>
      </div>
    </section>

    <section>
      <cds-input-wrapper label="Método de pagamento">
        <cds-payment-method placeholder="Selecione" formControlName="payment_methods" />
      </cds-input-wrapper>

      <h3 class="filters__label">Status do registro</h3>
      <fieldset class="filters__radios">
        @for (status of financialRecordStatusOptions; track status.value) {
          <label class="cds-input-wrapper">
            <input type="radio" class="cds-radio" formControlName="financial_record_status" [value]="status.value" />
            {{ status.label }}
          </label>
        }
      </fieldset>

      <h3 class="filters__label">Triagem</h3>
      <fieldset>
        <label class="filters__switch-row">
          <div>
            <i class="cds-icon-topic" aria-hidden="true"></i>
            Com documento
          </div>
          <span class="filters__switch">
            <input
              type="checkbox"
              aria-label="Somente registros com documento"
              [checked]="form.get('has_document')?.value === true"
              (change)="onCheckboxChange(true)"
            />
            <span></span>
          </span>
        </label>

        <label class="filters__switch-row">
          <div>
            <i class="cds-icon-folder-off" aria-hidden="true"></i>
            Sem documento
          </div>
          <span class="filters__switch">
            <input
              type="checkbox"
              aria-label="Somente registros sem documento"
              [checked]="form.get('has_document')?.value === false"
              (change)="onCheckboxChange(false)"
            />
            <span></span>
          </span>
        </label>

        <label class="filters__switch-row">
          <div>
            <i class="cds-icon-layers-clear" aria-hidden="true"></i>
            Sem setor/projeto
          </div>
          <span class="filters__switch">
            <input type="checkbox" aria-label="Somente registros sem setor ou projeto" formControlName="cost_center_null" />
            <span></span>
          </span>
        </label>
      </fieldset>
    </section>

    <button type="button" class="cds-button s-hollow c-primary" (click)="clearFilters()">Limpar filtros</button>

    <button type="submit" class="cds-button s-solid c-primary filters__submit" [disabled]="isDisabled()">
      Aplicar filtros
    </button>
  </form>
</main>
